import React from "react";
import { Opacity } from "@mui/icons-material";

/**
 * Get icon for humidity widgets
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getHumidityIcon = (widget = null) => {
  const iconProps = {
    style: {
      fontSize: "1.5rem",
      paddingBottom: "2px",
    },
  };

  return <Opacity {...iconProps} />;
};

export const getHumiditySubtitle = (widget = null) => {
  if (!widget) return "";

  const humidity = widget?.items?.$w1?.value;

  if (humidity !== undefined && humidity !== null) {
    return `${humidity}%`;
  }

  return "";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getHumidityPatterns = () => {
  return ["basic.device.humidity"];
};
